export default __webpack_public_path__ + "elva.366048be.jpg";